import React, {useRef, useState} from 'react';
import {GoodsType} from "../../../../entities/goods/model/types/goods-type";
import {useItemsPerRow} from "../../../../shared/hook/useItemsPerRow";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";
import {logDOM} from "@testing-library/dom";

interface IProps {
    products: GoodsType[];
    containerRef: React.RefObject<HTMLDivElement | null>; // контейнер родителя для подписки на изменение ширины екрана
    renderColumn: (product: GoodsType) => React.ReactNode;
    renderRow: (isViewRow: boolean) => React.ReactNode;
}
/**
 * Компонент-контейнер для отображения сетки товаров с возможностью
 * разворачивания строки под определённой карточкой.
 *
 * Позволяет динамически вставлять расширенную строку (`renderRow`) сразу
 * после строки, в которой была нажата карточка.
 *
 * @param products - Список товаров для отображения
 * @param containerRef - Ссылка на контейнер, используемая для вычисления количества элементов в строке
 * @param renderColumn - Функция-рендер одного элемента (карточки товара)
 * @param renderRow - Функция-рендер расширенной строки (показывается под строкой карточек)
 *
 * @returns JSX.Element — список карточек + динамически вставляемая расширенная строка
 */
const ProductRowExpander: React.FC<IProps> = ({products, renderColumn, containerRef, renderRow}) => {
    const itemsPerRow = useItemsPerRow(containerRef);
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

    const getInsertIndex = (index: number) => {
        const base = Math.ceil((index + 1) / itemsPerRow) * itemsPerRow;
        return Math.min(base, products!.length); // ← гарантия что не уйдём за предел
    };
    return (
        <>
            {products.map((goods, index) => {
                return (
                    <>
                        <div className={`${GLOBAL_STYLE_CONFIG.splitByPrefix('product-item')}`}
                             onClick={() => {
                                 setExpandedIndex(index);
                             }}
                        >
                            {renderColumn(goods)}
                        </div>

                        {renderRow((expandedIndex !== null && getInsertIndex(expandedIndex) - 1 === index))}
                    </>
                )
            })}
        </>
    );
};

export default ProductRowExpander;